export const ru = {
    active: 'Идет сбор данных.',
    'active-grid': 'Сбор данных',
    'and-grid': 'и',
    'budget-grid': 'бюджет',
    completed: 'Опрос завершен.',
    'completed-grid': 'Завершено',
    'coverage-grid': 'охват',
    draft: 'Черновик.',
    'draft-grid': 'Черновик',
    'low-grid': 'недостаточный {reason}',
    moderation: 'Отправлено на модерацию.',
    'moderation-grid': 'На модерации',
    'not-brand-grid': 'исследуемый бренд не ясен',
    reject: 'Исследование отклонено модерацией.',
    'reject-grid': 'Отклонено модерацией',
    'show-params-grid': 'посмотреть параметры',
    'show-result-grid': 'доступны результаты',
    stop: 'Опрос остановлен.',
    'stop-grid': 'Остановлено'
};
